module.exports = __webpack_public_path__ + "static/media/DigiSkryf_Thumbnail.8fe49a86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/DigiSkryf_Thumbnail.jpg
// module id = 815
// module chunks = 3